// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25b10c0d","389":"09616219","732":"9ef61cc2","971":"5a4003e0","977":"d371f55e"}[chunkId] + ".chunk.js";
};